import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import type { LoadableComponent } from '@townsquare/loadable/types';
import { RouteContext } from '@townsquare/router/routing-types';

export const SharedConversationPreviewLoadable: ComponentType<RouteContext> & LoadableComponent =
	Loadable({
		loader: () =>
			import(
				/* webpackChunkName: "shared-conversation-preview-view" */ './SharedConversationPreviewView'
			),
		loading: () => null,
	});
